// GENERATED FILE - DO NOT MODIFY

export enum ManagementRoleDto {
    None = "None",
    Administrator = "Administrator",
    Manager = "Manager",
}